import { APP_VERSION, COUNTRY_CODE, EnvironmentType } from "./environment.type";

export const environment: EnvironmentType = {
  placement: "prod",
  production: true,
  route_hash: false,
  timezone: "America/Argentina/Buenos_Aires",
  code: COUNTRY_CODE.ar,
  currency: "ARS",
  grammar: "ES",
  lang: "es",
  max_tip: 9000,
  phone_length: 10,
  phone_prefix: "+54",
  gateway: {
    base_url: "https://services.rappi.com.ar",
    csv_prefix: "/api/cargo-api-gateway/csv/portal/",
    gateway_prefix: "/api/cargo-api-gateway/portal/",
    location_gateway_prefix: "/api/cargo-api-gateway/core-maps/address/",
    settlement_prefix: "/api/cargo-api-gateway/portal/settlement/",
    cashless_prefix: "/api/ms/cargo-cashless/",
    maps_prefix: "/api/maps/v1/",
  },
  logoUrl: "https://cargo-core-api.s3.us-west-2.amazonaws.com/ar/cargo-logos/",
  aws_location: {
    api_key:
      "v1.public.eyJqdGkiOiI0NWFlNmVmNi1mOWYzLTRiMmMtOGE2Yi03MmRlMmQxNmRiNGEifYE3Er-B4o10YxEtPt4ylVDg_2hoJerXHrKVFuPaiZOPEK6Vm2i0gpTzueqrmBuvZT500T2wuumGFP1WBnvxpPTlI0HN-rh0UkzEF57PVand2buy2nRLNSkaL1ONCdSbVDnZ4QQdr0zn6gTZ20BACSWNR4EuKdaMacLmMNTOf6_t0vkxmgXdwumyDlC786jfBBFrKfI8mm9k7BWLaRBjxWQa2DBHJ6rOw3KwSAvfv6WypEo2vEh8QgdkpsNEqxwusCwewHyQ4CJAlSpGoL7_Im2_yoBjr7L0QlKpZpeCJFHm_ZnIxJJCB9bKoN3M3iQtUkizD8AK2lmqQZ-tjDJxQDg.ZWU0ZWIzMTktMWRhNi00Mzg0LTllMzYtNzlmMDU3MjRmYTkx",
    region: "us-east-1",
    style: "Standard",
    color_scheme: "Light",
  },
  trackingUrl: "cargo-tracking.rappi.com.ar/",
  coordsCenter: { lat: -34.61315, lng: -58.37723 },
  currencySymbol: "$",
  decimalPattern: /^[0-9]+([.]\d{0,0})?$/,
  decimalNumber: 0,
  country: {
    defaultLocale: "es-AR",
  },
  localeUrl: "https://cargo-core-api.s3.amazonaws.com/ar/cargo-logos/",
  auth0: {
    client_id: "hDcAOaY9heMYiAxYPvr5Ynt3ZeNybA43",
    client_secret: "OxnMGuC8OXHjYTgznaaKL2ItdOB4xdMj2jpTDbx6au00NQX47lBEdjgGXc6ia2m4",
    domain: "https://login.partners.rappi.com",
  },
  amplitude: {
    key: "032f00f0dfdad881e7391f28f35156f6",
  },
  i18n_version: APP_VERSION,
  kustomer_assistant_id: "664bbe3419e7a2316b52dc7a",
  recaptcha_site_key: "6Le98o0sAAAAAMT-KoXGJs6OW-aYF9sbNdbigJaR",
  amazon_connect: {
    snippet_id:
      "QVFJREFIaGRXUHpDQ0syTWozT3FtUTlKL1lZeW8zbzdUZEQ4Y1A3d0wzMWFuQ0RFM0FIUjdSZEdzTzJWYWV1Ynl4NjY4QmRCQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNWXRNZ0JBWUpaUHM2NkhSSkFnRVFnQ3NiNFdUQ0xxSVVDVXBTRldTQzlGU0xSanRhYTFXWm5kMG85RWRBNnB6TDV0bnFRRnQ4V1JlVVhDVGg6OmNGZ0IwVjVrUEhIWlIwNDAyN0ZTTmtMcUpseTYvVlI0enFiSkpCWTVDazQxV3BlTmlKN2V6VDUyblpDYmswMjRlS3NIQnlWN2ZiN3NTNmN3UHBFdjczbGVWRDhkMDlBb25sTGgxUVlGcStIcC9wSVlISDhSa2orSjdDQVIwaEJTZEdNQWJML2g1OXIrZ1RNUWhReXFOSTNDS3puS2RRUT0=",
    src: "https://connect-rappi-support-prod.my.connect.aws/connectwidget/static/amazon-connect-chat-interface-client.js",
    script_id: "37223493-6644-445d-bae1-7074a64d629c",
  },
};
